export const COMMON_CONSTANTS: any = {
    ENTER_KEY_CODE: 13,
    ROWS_PER_PAGE_SETTINGS: [20, 50, 100],
    ROWS_PER_PAGE_SETTINGS_SP: 20,
    FIRST_PAGE: 0,
    FIRST_PAGE_OFFSET: 0,
    INVALID_CALCULATE_RESULT: 'ー',
    DISPLAY_ORDER_FACILITY: 0,
}

export const NotReRendering: boolean = true
